import LandingIndex from "./pages/index/index";
import SearchPage from "./pages/search/search";

const BaseRoutes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: LandingIndex
  },
  {
    path: "/search",
    name: "search",
    component: SearchPage
  }
];

export { BaseRoutes };
